module.exports = __webpack_public_path__ + "static/media/profile.6c70eada.svg";